import { render } from "./App.vue?vue&type=template&id=f2895012"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\RE ALIMAS\\alimasweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__